<template>
  <div>
    <p class="paragraph--green">
      Punkty do wykorzystania:
      <strong
        >{{
          parseFloat(user.total_points).toFixed(1).replace(".", ",")
        }}&nbsp;pkt.</strong
      ><br />
      <small
        ><b
          ><router-link :to="{ name: 'PointsHistory' }" class="paragraph--green"
            >Historia &raquo;</router-link
          ></b
        ></small
      >
    </p>
    <p
      class="paragraph--green"
      v-if="!user.is_certyficated && parseFloat(user.total_premium_points) > 0"
    >
      Total punktów w programie Geberit Pro
      <strong
        >{{
          (
            parseFloat(user.total_premium_points) +
            parseFloat(user.total_points)
          )
            .toFixed(1)
            .replace(".", ",")
        }}&nbsp;pkt.</strong
      >
      <small class="text-danger">*</small><br />
    </p>

    <p class="danger" v-if="user.points_to_loss > 0">
      <br />
      <strong>{{ parseFloat(user.points_to_loss).toFixed(1) }} pkt</strong>
      wykorzystaj<br />
      przed {{ moment(user.next_expire_date).format("DD-MM-YYYY") }}
    </p>

    <div
      class="rules-info mb-1"
      v-if="!user.is_invoiced || !user.is_certyficated"
    >
      <p class="danger" v-if="!user.is_invoiced">
        <router-link :to="{ name: 'InvoicesAdd' }" class="danger"
          ><b>Zarejestruj</b></router-link
        >
        pierwszą fakturę aby wymieniać punkty na nagrody!
      </p>

      <p
        class="danger"
        v-if="
          !user.is_certyficated &&
          (user.certyficate_progress.need - user.certyficate_progress.have >
            0 ||
            true)
        "
      >
        Brakuje Ci
        <b
          >{{
            user.certyficate_progress.need - user.certyficate_progress.have < 0
              ? 0
              : parseFloat(
                  user.certyficate_progress.need -
                    user.certyficate_progress.have
                ).toFixed(2)
          }}zł</b
        >, aby uzyskać dostęp do nowych nagród, dostępnych dla
        <router-link :to="{ name: 'Rules' }" class="danger"
          ><b>Certyfikowanego Instalatora.</b>
          <small class="text-danger">*</small
          ><small
            v-if="
              !user.is_certyficated && parseFloat(user.total_premium_points) > 0
            "
            class="text-danger"
            >*</small
          ></router-link
        >
      </p>

      <p
        class="danger"
        v-if="
          !user.is_certyficated &&
          user.certyficate_progress.need - user.certyficate_progress.have <=
            0 &&
          false
        "
      >
        <strong>Gratulacje!</strong><br />
        Zarejestrowano już kwotę wymaganą do uzyskania certyfikatu! <br />
        <span
          id="show-modal-reneve"
          class="mouse-hover"
          @click="show('uninvoiced-user-modal')"
          >Przejdź szkolenie i zalicz test</span
        >
        aby zostać
        <router-link :to="{ name: 'Rules' }" class="danger mouse-hover"
          ><b>Certyfikowanym Instalatorem</b></router-link
        >
        i uzyskać dostęp do nowych nagród.
      </p>

      <modal name="uninvoiced-user-modal">
        <div class="row h-100 text-dark">
          <span
            @click="hide('uninvoiced-user-modal')"
            class="prize__close"
          ></span>
          <div
            class="col-md-1 d-flex justify-content-center align-items-center uncertified-user-modal__img"
          ></div>
          <div
            class="col-md-10 d-flex justify-content-center align-items-center uncertified-user-modal__desc"
          >
            <div>
              <h2><strong>Uzyskanie certyfikatu</strong></h2>
              <p>
                Uzyskanie statusu Certyfikowanego Instalatora wymaga rejestracji
                faktur na kwotę 30,000pln oraz udziału w stacjonarnym szkoleniu
                Certyfikującym Geberit Pro i zaliczenia Testu Wiedzy lub 3
                (trzech) szkoleń online i zaliczenia Skróconych Testów Wiedzy.
              </p>
            </div>
          </div>
        </div>
      </modal>
    </div>

    <p
      v-if="!user.is_certyficated && parseFloat(user.total_premium_points) > 0"
    >
      <small
        ><span class="text-danger">*</span> Uwaga! Total punktów do
        wykorzystania po zdobyciu Certyfikatu Geberit Pro.</small
      >
    </p>

    <p
      v-if="
        !user.is_certyficated &&
        (user.certyficate_progress.need - user.certyficate_progress.have > 0 ||
          true)
      "
    >
      <small>
        <span class="text-danger">*</span
        ><span
          class="text-danger"
          v-if="
            !user.is_certyficated && parseFloat(user.total_premium_points) > 0
          "
          >*</span
        >
        <span
          id="show-modal-reneve"
          class="mouse-hover"
          @click="show('uninvoiced-user-modal')"
          >Pamiętaj, że aby uzyskać status Certyfikowanego Instalatora
          potrzebujesz jeszcze odbyć szkolenie i zaliczyć Testy Wiedzy</span
        >.
      </small>
    </p>
    <br />
  </div>
</template>

<script>
import Vue from "vue";
import { store } from "@/app/store";

export default {
  name: "PrizeComponent",
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    show(el) {
      this.$modal.show(el);
    },
    hide(el) {
      this.$modal.hide(el);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/UserPointsInfoWidget.vue